import React from 'react';
import { motion } from 'framer-motion';
import { portfolioSummary } from '@/data/labsProducts';

const PortfolioSummary: React.FC = () => {
  return (
    <section id="portfolio" className="relative py-24 px-4 border-t border-[#1F1F2E]">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-[11px] uppercase tracking-widest text-[#8B5CF6] mb-4 block">Portfolio</span>
          <h2 className="font-space-grotesk text-3xl sm:text-4xl font-bold text-white">
            Year 3 Revenue Potential
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-xl border border-[#1F1F2E] bg-[#0F0F18] overflow-hidden"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#1F1F2E]">
                <th className="text-left py-3 px-4 sm:px-6 text-[#A1A1AA]/50 text-xs font-medium">#</th>
                <th className="text-left py-3 px-4 sm:px-6 text-[#A1A1AA]/50 text-xs font-medium">Product</th>
                <th className="text-center py-3 px-4 sm:px-6 text-[#A1A1AA]/50 text-xs font-medium">Status</th>
                <th className="text-right py-3 px-4 sm:px-6 text-[#A1A1AA]/50 text-xs font-medium">Year 3 Revenue</th>
              </tr>
            </thead>
            <tbody>
              {portfolioSummary.map((item, i) => (
                <tr
                  key={item.name}
                  className={`border-b border-[#1F1F2E]/50 ${i % 2 === 1 ? 'bg-[#1F1F2E]/10' : ''}`}
                >
                  <td className="py-3 px-4 sm:px-6 text-[#A1A1AA]/40 text-xs">{i + 1}</td>
                  <td className="py-3 px-4 sm:px-6 text-white text-xs sm:text-sm">{item.name}</td>
                  <td className="py-3 px-4 sm:px-6 text-center">
                    {i < 2 ? (
                      <span className="text-[9px] px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 uppercase tracking-wider font-semibold">
                        Live
                      </span>
                    ) : (
                      <span className="text-[9px] px-2 py-0.5 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/30 text-[#3B82F6] uppercase tracking-wider font-semibold">
                        Building
                      </span>
                    )}
                  </td>
                  <td className="py-3 px-4 sm:px-6 text-right">
                    <span className="bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] bg-clip-text text-transparent font-semibold text-xs sm:text-sm">
                      {item.revenue}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="border-t border-[#3B82F6]/20 bg-[#3B82F6]/5">
                <td className="py-4 px-4 sm:px-6" />
                <td className="py-4 px-4 sm:px-6 text-white font-bold text-sm">TOTAL</td>
                <td className="py-4 px-4 sm:px-6" />
                <td className="py-4 px-4 sm:px-6 text-right">
                  <span className="font-space-grotesk font-bold text-lg bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] bg-clip-text text-transparent">
                    MX$1.87B (~$104M USD)
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </motion.div>
      </div>
    </section>
  );
};

export default PortfolioSummary;
